export const SidebarData = [
  {
    title:'Job Auditing',
    path:'/jobAudit'
  },
  {
    title:'Console Bill Genaration',
    path:'/conslBills'
  },
  {
    title:'Separate Bill Genaration',
    path:'/sepbill'
  },
  {
    title:'First Level Bill',
    path:'/1stlvl'
  },
  {
    title:'Second Level Bill',
    path:'/2ndlvl'
  },
  {
    title:'Bill Auditing',
    path:'/billaudit'
  },
  {
    title:'Bill Submission',
    path:'/billSub'
  },
];

export const BillReportData=[
  {
    title:'Invoice BillDownload',
    path:'/InvoiceBillDownload'
  },
  {
    title:'Multiple BillDownload',
    path:'/MultipleBillDownload'
  },
  {
    title:'ConsoleBill InvoiceReport',
    path:'/ConsoleBillInvoiceReport'
  },
  {
    title:'Supplimentary BillReport',
    path:'/SupplimentaryBillReport'
  },
  {
    title:'Quotation Download',
    path:'/QuotationDownload'
  },
  {
    title:'Tally Integration Report',
    path:'/TallyIntegrationReport'
  },
  {
    title:'Bill Summary Report',
    path:'/BillSummaryReport'
  },
  {
    title:'Bill Details Report',
    path:'/BillDetailsReport'
  },
  {
    title:'GSTR1 Reports',
    path:'/GSTR1Reports'
  },
  {
    title:'Customer Wise Bill Reports',
    path:'/CustomerWiseBillReports'
  },
]
export const FundReportData=[
  {
    title:'Fund Status Report',
    path:'/FundStatus'
  },
  {
    title:'Fund Refund Report',
    path:'/FundRefundReport'
  },
]
export const DailyReportData=[
  {
    title:'DSR1 Report',
    path:'/DSR1'
  },
  {
    title:'DSR2 Report',
    path:'/DSR2'
  },
  {
    title:'DSR3 Report',
    path:'/DSR3'
  },
]
export const OpretionReportData=[
  {
    title:'Docs_Emp_Wise Report',
    path:'/DocumentationEmployeeReport'
  },
  {
    title:'Billing_Department Employee_Report',
    path:'/BillingDepartmentEmployeeReport'
  },
  {
    title:'Fund_Request Wise_Employee_Report',
    path:'/FundRequestEmployeeReport'
  },
  {
    title:'Payment_Expense Wise Employee_Report',
    path:'/PaymentExpenseEmployeeReport'
  },
  {
    title:'Operation_DeptWise Employee_Report',
    path:'/OperationDeptWiseEmployeeReport'
  },
  {
    title:'Branch Wise Report',
    path:'/BranchWiseReport'
  },
  {
    title:'Customer Wise Report',
    path:'/CustomerWiseReport'
  },
  {
    title:'Billing Wise Report',
    path:'/BillingWiseReport'
  },
  {
    title:'Expense Report',
    path:'/ExpenseReport'
  },
  {
    title:'Profit And Lose Report',
    path:'/ProfitAndLoseReport'
  },
  {
    title:'Checklist Excel Report',
    path:'/ChecklistExcelReport'
  },
]
export const PaymentEstimationData=[
  {
    title:'Fund Request',
    path:'/fundreq'
  },
  {
    title:'Fund Approval',
    path:'/fundaprvl'
  },
  {
    title:'Fund 1stLevel_Verification',
    path:'/fund1stlvlvrfy'
  },
  {
    title:'Fund 2ndLevel_Verification',
    path:'/fund2ndlvlvrfy'
  },
  {
    title:'Fund Allocation',
    path:'/fundallocation'
  },
  {
    title:'Fund Release',
    path:'/fundrels'
  },
  {
    title:'Fund Upload Recepit Copy',
    path:'/fund_rcptCpy'
  },
  {
    title:'Fund Audit',
    path:'/fundaudit'
  },
  {
    title:'Fund Refund',
    path:'/fundrefund'
  },
]
export const Place=[
  {
    title:'Country',
    path:'/Country'
  },
  {
    title:'State',
    path:'/State'
  },
  {
    title:'Clearance Location',
    path:'/ClearanceLoc'
  },
]
export const Billing_Details=[
  {
    title:'Charge Type',
    path:'/Chargetype'
  },
  {
    title:'Item Type',
    path:'/Itemtype'
  },
  {
    title:'Bill Charge',
    path:'/Billcharge'
  },
  {
    title:'Quotation Importer ',
    path:'/qutationImporter'
  },
  {
    title:'Quotation Forwarder ',
    path:'/qutationForwarder'
  },
  {
    title:'Unit Of Measurement',
    path:'/Unitofmeasurement'
  },
]
export const Accounts=[
  {
    title:'Account',
    path:'/Account'
  },
  {
    title:'Bill Paid To',
    path:'/Billpaidto'
  },
  {
    title:'Bill Paid By',
    path:'/Billpaidby'
  },
  {
    title:'Payment',
    path:'/Payment'
  },
  {
    title:'Printed Type',
    path:'/Printedtype'
  },
  {
    title:'Voucher',
    path:'/Voucher'
  },
]
